module.exports = __webpack_public_path__ + "static/media/screen-primary-02.04b977ed.jpg";